import { FC } from 'react';
import AnalyticsInfo from '@/features/finances/components/Analytics/AnalyticsInfo';

type Props = {
	apartmentId: string;
	isMobile?: boolean;
};

const ApartmentsDetailsFinances: FC<Props> = ({ apartmentId, isMobile }) => {
	return (
		<div className='flex flex-col gap-6 select-none'>
			<AnalyticsInfo
				apartmentId={apartmentId}
				isMobile={isMobile}
			/>			
		</div>
	);
};

export default ApartmentsDetailsFinances;
